import NProgress from 'nprogress'
import { push } from 'connected-react-router'
import { differenceInCalendarDays } from 'date-fns'

import { Subscription, LocaleTypes, ThunkResult, ActionTypes } from './types'
import * as types from './types'
import { token } from './index'

export function sendCallAssistant(): ThunkResult<Promise<any>> {
	return (dispatch) => {
		const payload = new FormData()
		payload.append('call_assistant', 'true')
		payload.append('ajax', 'true')

		dispatch({
			type: types.CALL_ASSISTANT,
		})

		return fetch('https://shop.futurestorearnhem.nl/notification', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
			headers: {
				'Accept': 'application/json',
			},
		})
			.then(() => dispatch(callAssistantFulfilled()))
			.catch(reason => dispatch(callAssistantRejected()))
	}
}

export function resetAssistant(): ActionTypes {
	return {
		type: types.RESET_ASSISTANT,
	}
}

export function callAssistantFulfilled(): ActionTypes {
	return {
		type: types.CALL_ASSISTANT_FULFILLED,
	}
}

export function callAssistantRejected(): ActionTypes {
	NProgress.done()

	return {
		type: types.CALL_ASSISTANT_REJECTED,
	}
}

export function setLocale(locale?: LocaleTypes): ActionTypes {
	return {
		type: types.SET_LOCALE,
		payload: {
			locale: typeof locale === 'undefined'
				? window.navigator.language.substr(0, 2) as LocaleTypes
				: locale,
		}
	}
}

export function startScanning(): ActionTypes {
	return {
		type: types.START_SCANNING,
	}
}

export function stopScanning(): ActionTypes {
	return {
		type: types.STOP_SCANNING,
	}
}

export function detectBarcode(barcode: string): ActionTypes {
	return {
		type: types.DETECT_BARCODE,
		payload: {
			barcode,
		},
	}
}

export function searchBarcode(barcode: string): ThunkResult<Promise<any>> {
	return (dispatch) => {
		dispatch({
			type: types.SEARCH_BARCODE,
			payload: {
				barcode,
			}
		})

		return fetch(`https://shop.futurestorearnhem.nl/rest/products?barcode=${barcode}`, {
			method: 'GET',
			credentials: 'same-origin',
			headers: {
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
		})
			.then(result => {
				if (result.ok) {
					return result.json()
				}

				throw new Error()
			})
			.then(response => {
				dispatch(push(`/product/${barcode}`))
				dispatch(searchBarcodeFulfilled(response))
			})
			.catch((error) => {
				console.log(error)
				dispatch(push('/'))
			})
	}
}

export function searchBarcodeFulfilled(response: any): ActionTypes {
	const shelfDate = new Date(response.result.shelf_date)
	const difference = differenceInCalendarDays(shelfDate, new Date())

	console.log(response.result)

	return {
		type: types.SEARCH_BARCODE_FULFILLED,
		payload: {
			product: response.result.product ?? null,
			option: response.result.option ?? null,
			price: response.result.price ?? null,
			location: response.result.location ?? [],
			stocks: response.result.stocks ?? [],
			bestBefore: response.result.shelf_date === null
				? null
				: difference,
		}
	}
}

export function fetchProduct(id: string): ThunkResult<Promise<any>> {
	return (dispatch) => {
		dispatch({
			type: types.FETCH_PRODUCT,
			payload: { id },
		})

		return fetch(`https://shop.futurestorearnhem.nl/rest/products/${id}`, {
			method: 'GET',
			credentials: 'same-origin',
			headers: {
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
		})
			.then(result => {
				if (result.ok) {
					return result.json()
				}

				throw new Error()
			})
			.then(response => {
				dispatch(fetchProductFulfilled(response))
			})
	}
}

export function fetchProductFulfilled(response: any): ActionTypes {
	return {
		type: types.FETCH_PRODUCT_FULFILLED,
		payload: {
			product: response.result.product ?? null,
		}
	}
}

export function subscribeFulfilled(): ActionTypes {
	return {
		type: types.SUBSCRIBE_FULFILLED,
	}
}

export function subscribeRejected(): ActionTypes {
	return {
		type: types.SUBSCRIBE_REJECTED,
	}
}

export function subscribe(subscription: Subscription): ThunkResult<Promise<any>> {
	return (dispatch) => {
		const payload = new FormData()
		payload.append('fields[name][first]', subscription.firstname)
		payload.append('fields[name][last]', subscription.lastname)
		payload.append('fields[email]', subscription.email)
		payload.append('fields[group][]', '5')
		payload.append('submit', JSON.stringify(true))
		payload.append('form_id', '8')

		console.log(payload)

		dispatch({
			type: types.SUBSCRIBE,
			payload: {
				subscription,
			}
		})

		return fetch('https://shop.futurestorearnhem.nl/', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
			headers: {
				'Accept': 'application/json',
			},
		})
			.then(() => dispatch(subscribeFulfilled()))
			.catch(reason => {
				console.log(reason)
				return dispatch(subscribeRejected())
			})
	}
}


